import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { reduxForm } from 'redux-form';
import { ActionForm } from './ActionForm';
import { flashActions } from '../../../actions';
import { axiosInstance } from '../../../utils';

const OnHoldForm = ({
  handleSubmit,
  submitFailed,
  closeModal,
  id,
  reloadPage,
  setProcessing,
}) => {
  const newState = useSelector(state => state.form.OnHold);
  const { values, syncErrors } = newState || {};

  const dispatch = useDispatch();

  const textField = [
    {
      name: 'note',
      component: 'input',
      type: 'textarea',
      label: 'Add a note for this action which will be displayed in the Document History for future reference:',
      placeholder: 'Write your message...',
    },
  ];

  const onSubmit = async () => {
    setProcessing(true);
    closeModal();
    const note = values && values.note ? values.note : '';

    axiosInstance
      .patch(`v1/documents/${id}/invoice/update_status`, { status_note: note, commit: 'hold' })
      .then(() => {
        setProcessing(false);
        dispatch(flashActions.showSuccess('The invoice has been placed on hold'));
        reloadPage();
      })
      .catch(error => {
        setProcessing(false);
        dispatch(flashActions.showError(error));
      });
  };

  return (
    <div className="cancel-hold-invoice-container">
      <h3 className="cancel-hold-invoice-title">Are you sure wish to place this invoice On Hold?</h3>
      <div className="alert alert--warning">
        <strong>WARNING:</strong>
        &nbsp;If you place an invoice on hold it will not reflect as a liability on Strata Master financial statements or status certificates.
      </div>
      <ActionForm
        handleSubmit={handleSubmit}
        submitFailed={submitFailed}
        values={values}
        syncErrors={syncErrors}
        onSubmit={onSubmit}
        field={textField}
        closeModal={closeModal}
        buttonText="Place on hold"
        actionButtonColor="green"
      />
    </div>
  );
};

export const OnHold = reduxForm({
  form: 'OnHold',
})(OnHoldForm);
